import {Routes} from '@angular/router';
import {AuthGuard} from './service/core/auth-guard.service';
import {ServicosGuard} from '@service/core/servicos-guard.service';

export const AppRoutes: Routes =
  [{
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  }, {
    path: '',
    children: [{
      canActivate: [ServicosGuard],
      path: '',
      loadChildren: './auth/auth.module#AuthModule'
    }]
  }, {
    path: '',
    //canActivate: [AuthGuard, ServicosGuard],
    canActivate: [ServicosGuard],
    children: [{
      path: '',
      loadChildren: './admin/admin.module#AdminModule'
    }],
  }];



// WEBPACK FOOTER //
// ./src/app/app-routing.ts